<template>
  <div class="pagina ativa" id="paginaMinhaSenha">
    <div class="pagina-titulo" style="display:flex;align-items:center;gap:9px;"><KeyRound :size="20" /> Minha Senha</div>
    <div style="background:white;border-radius:10px;padding:30px;box-shadow:0 2px 8px rgba(0,0,0,0.08);max-width:400px;">
      <div style="margin-bottom:20px;color:#555;font-size:14px;">Alterando senha de: <strong>{{ sessao.nome }}</strong></div>
      <label>SENHA ATUAL</label><input type="password" v-model="senhaAtual" placeholder="Senha atual" />
      <label>NOVA SENHA</label><input type="password" v-model="senhaNova" placeholder="Nova senha" />
      <label>CONFIRMAR</label><input type="password" v-model="senhaConfirmar" placeholder="Confirme" />
      <button @click="salvar" style="width:100%;margin-top:15px;">Salvar Nova Senha</button>
      <div class="status" :class="statusClasse">{{ statusMsg }}</div>
    </div>
  </div>
</template>

<script>
import { apiPost, getSession } from '../api'
import { KeyRound } from 'lucide-vue-next'

export default {
  components: { KeyRound },
  name: 'PaginaMinhaSenha',
  data() {
    return {
      sessao: getSession(),
      senhaAtual: '',
      senhaNova: '',
      senhaConfirmar: '',
      statusMsg: '',
      statusClasse: ''
    }
  },
  methods: {
    async salvar() {
      this.statusMsg = ''
      if (!this.senhaAtual || !this.senhaNova || !this.senhaConfirmar) {
        this.statusClasse = 'erro-msg'
        this.statusMsg = 'Preencha todos os campos.'
        return
      }
      if (this.senhaNova !== this.senhaConfirmar) {
        this.statusClasse = 'erro-msg'
        this.statusMsg = 'As senhas nao coincidem.'
        return
      }
      const r = await apiPost('auth/alterar-senha', { senhaAtual: this.senhaAtual, senhaNova: this.senhaNova })
      if (r.sucesso) {
        this.statusClasse = 'sucesso'
        this.statusMsg = 'Senha alterada com sucesso!'
        this.senhaAtual = ''
        this.senhaNova = ''
        this.senhaConfirmar = ''
      } else {
        this.statusClasse = 'erro-msg'
        this.statusMsg = r.mensagem || 'Erro ao alterar senha.'
      }
    }
  }
}
</script>
